/**
 * Giriş / kayıt / etkinleştirme sonrası dönüş adresi (return URL).
 *
 * Mekanizma Login ile aynı: react-router `location.state.from` (string ya da location nesnesi).
 * Kayıt → etkinleştirme sayfasında yenileme yapılırsa state kaybolmasın diye aynı sekmede sessionStorage yedeği tutulur.
 *
 * Güvenlik: yalnızca site içi göreli yollar kabul edilir ("/" ile başlar; "//" ya da "/\" ile başlamaz, ters bölü ve
 * kontrol karakteri içermez). Dış adrese (açık yönlendirme) asla gidilmez. Giriş/kayıt sayfalarının kendisine dönüş yok sayılır.
 */

const STORAGE_KEY = 'auth:returnTo';
const AUTH_PATHS = ['/login', '/register', '/activation', '/social-complete', '/forgot-password'];

/** Değer (string | { pathname, search, hash }) → güvenli göreli yol ya da null */
export const safeReturnPath = (value) => {
  let v = value;
  if (v && typeof v === 'object') v = `${v.pathname || ''}${v.search || ''}${v.hash || ''}`;
  if (typeof v !== 'string') return null;
  v = v.trim();
  if (!v || v.length > 2048) return null;
  if (v[0] !== '/' || v[1] === '/' || v[1] === '\\') return null;
  // Tarayıcılar "\" karakterini "/" sayar ("/\evil.com" → "//evil.com"); kontrol karakterleri de reddedilir
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001f\u007f]/.test(v)) return null;
  const path = v.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  if (AUTH_PATHS.includes(path.toLowerCase())) return null;
  return v;
};

/** location → navigate(..., { state }) için dönüş state'i (yoksa undefined) */
export const returnStateFrom = (location) => {
  const from = safeReturnPath(location?.state?.from);
  return from ? { from } : undefined;
};

const storage = () => {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch {
    return null;
  }
};

/** Dönüş adresini sekme oturumuna yazar; geçersiz/boşsa eski değeri siler (eski bir hedefe yanlışlıkla dönülmesin). */
export const rememberReturnTo = (value) => {
  const s = storage();
  if (!s) return;
  const safe = safeReturnPath(value);
  try {
    if (safe) s.setItem(STORAGE_KEY, safe);
    else s.removeItem(STORAGE_KEY);
  } catch {
    /* özel mod / kota */
  }
};

/** Önce state, yoksa sessionStorage yedeği; okunan yedek silinir. Güvenli değilse null. */
export const consumeReturnTo = (location) => {
  const fromState = safeReturnPath(location?.state?.from);
  const s = storage();
  let stored = null;
  try {
    stored = s ? s.getItem(STORAGE_KEY) : null;
    if (s) s.removeItem(STORAGE_KEY);
  } catch {
    stored = null;
  }
  return fromState || safeReturnPath(stored);
};
